import { render, staticRenderFns } from "./CreationModified.vue?vue&type=template&id=2ca75f87"
import script from "./CreationModified.vue?vue&type=script&lang=js"
export * from "./CreationModified.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports